.spectrum--lightest .spectrum-Menu {
  background-color: transparent;
}
.spectrum--lightest .spectrum-Menu-item {
  background-color: transparent;
  color: rgb(80, 80, 80);
}
.spectrum--lightest .spectrum-Menu-item.focus-ring,
.spectrum--lightest .spectrum-Menu-item.is-focused {
    background-color: rgba(50,50,50,0.04);
    color: rgb(80, 80, 80);
    border-left-color: rgb(55, 142, 240);
  }
.spectrum--lightest .spectrum-Menu-item:hover,
.spectrum--lightest .spectrum-Menu-item:focus,
.spectrum--lightest .spectrum-Menu-item.is-highlighted,
.spectrum--lightest .spectrum-Menu-item.is-open {
    background-color: rgba(50,50,50,0.04);
    color: rgb(80, 80, 80);
  }
.spectrum--lightest .spectrum-Menu-item.is-selected {
    color: rgb(80, 80, 80);
  }
.spectrum--lightest .spectrum-Menu-item.is-selected .spectrum-Menu-checkmark {
      color: rgb(38, 128, 235);
    }
.spectrum--lightest .spectrum-Menu-item .is-active,
.spectrum--lightest .spectrum-Menu-item:active {
    background-color: rgba(50,50,50,0.04);
  }
.spectrum--lightest .spectrum-Menu-item.is-disabled {
    background-color: transparent;
    background-image: none;
    color: rgb(188, 188, 188);
    cursor: default;
  }
.spectrum--lightest .spectrum-Menu-sectionHeading {
  color: rgb(116, 116, 116);
}
.spectrum--lightest .spectrum-Menu-divider {
  background-color: rgb(255, 255, 255);
}
